// removed by extract-text-webpack-plugin
module.exports = {"overlay-drop-shadow":"overlay-drop-shadow-15bb9c","sapcnqr-overlay":"sapcnqr-overlay-374d2a","sapcnqr-overlay__content":"sapcnqr-overlay__content-f10cb2"};